module.exports = __webpack_public_path__ + "img/wallet_02_biometric_2.4a7221db.png";